import React from 'react';
import CaregiverCommunicationPage from '../../../CaregiverCommunicationPage';
import './MessagesFragment.css';

function MessagesFragment() {
    return (
       
        <CaregiverCommunicationPage />
        
    );
}

export default MessagesFragment;

